import React, {ReactNode} from 'react';
import {useAuth} from '../../contexts/AuthContext';
import MembershipUpgradePage from './MembershipUpgradePage';

/**
 * 会员等级路由门卫（需求 1.14「显示+升级引导」策略）
 * 等级不足时内联渲染升级引导页（URL 不变，返回首页/联系运营出口）；
 * ADMIN 经 hasMemberLevel 豁免。
 *
 * @author page
 * @date 2026-10-15
 */
interface Props {
    requiredLevel: number;
    children: ReactNode;
}

const MembershipGate: React.FC<Props> = ({requiredLevel, children}) => {
    const {hasMemberLevel} = useAuth();

    if (!hasMemberLevel(requiredLevel)) {
        return <MembershipUpgradePage requiredLevel={requiredLevel}/>;
    }
    return <>{children}</>;
};

export default MembershipGate;
